import { diff } from "deep-diff";

export function checkIfItemsHaveDifferences<TEntity>(a: TEntity, b: TEntity): boolean {
  const differences = diff(a, b);
  return !!(differences && differences.length > 0);
}
